import { BlogMarkdown } from './BlogMarkdown';

export function formatLogDate(logDate: string) {
  const [y, m, d] = logDate.split('-').map(Number);
  if (!y || !m || !d) return logDate;
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
  });
}

interface EntryLike {
  id?: string;
  title: string | null;
  logDate: string;
  location: string;
  body: string;
}

export function BlogEntry({ post, testId }: { post: EntryLike; testId?: string }) {
  return (
    <article id={post.id ? `entry-${post.id}` : undefined} className="blog-entry scroll-mt-28" data-testid={testId}>
      <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground flex flex-wrap gap-x-3 gap-y-1">
        <time dateTime={post.logDate}>{formatLogDate(post.logDate)}</time>
        <span aria-hidden="true" className="text-primary">/</span>
        <span>{post.location}</span>
      </p>
      {post.title && (
        <h2 className="mt-5 text-2xl md:text-[1.75rem] font-medium tracking-tight text-foreground text-balance leading-snug">
          {post.title}
        </h2>
      )}
      <div className={post.title ? 'mt-6' : 'mt-5'}>
        <BlogMarkdown body={post.body} />
      </div>
    </article>
  );
}
